import * as React from "react";
import { BaseBlock, BaseBlockOptions, broadcastBlockLoad } from "sb-resp-lib";

import { BaseDict } from "./dict";
import { config } from "./config";
import { RacingNextRaces } from "./RacingNextRaces";
import { RacingNextRacesData } from "./data";

/*
    This structure allows us to use mocks during dev
    but not to include them when we do build:release
*/
import * as MOCKSTYPE from "sb-resp-lib/lib/mocks";
import * as LOCALMOCKS from "../../mocks";
let _: typeof MOCKSTYPE;
let _localMocks: typeof LOCALMOCKS;
let PageMethodsMock;
let RacingPageMethodsMock;
let OverridenPageMethodsResponses;
let BetSlipUtilMock;
let OddsMock;
let PushOddsFacadeMock;
let GetUniqueClassMock;

if (process.env.NODE_ENV === "development") {
    //import { BetSlipUtilMock, OddsMock } from "sb-resp-lib/lib/mocks";
    _ = require("sb-resp-lib/lib/mocks");
    _localMocks = require("../../mocks");
    PageMethodsMock = _.PageMethodsMock;
    RacingPageMethodsMock = _localMocks.RacingPageMethodsMock;
    OverridenPageMethodsResponses = _localMocks.PageMethodsOverridenMockedMethods;
    BetSlipUtilMock = _.BetSlipUtilMock;
    OddsMock = _.OddsMock;
    PushOddsFacadeMock = _.PushOddsFacadeMock;
    GetUniqueClassMock = _.getUniqueOddsClass;
}

export class RacingNextRacesRoot extends BaseBlock {
    dataProvider!: RacingNextRacesData;
    options!: BaseBlockOptions;

    // constructor sets defaults
    constructor(
        domId: string,
        options: BaseBlockOptions = {
            dict: BaseDict,
            cms: {},
            navHandler: {},
            dataProvider: {},
            betSlipUtil: BetSlipUtil,
            oddsUtil: Odds,
            facade: Facade
        }
    ) {
        super(domId, options);

        // if no provided dictionary is not full fill in the missing keys with the base one
        this.options.dict = { ...BaseDict, ...(options.dict || {}) };

        // merge default and CMS options
        this.options.cms = { ...config, ...(options.cms || {}) };

        if (process.env.NODE_ENV === "development") {

            // setup data mocks for debug build
            this.dataProvider = new RacingNextRacesData({
                pageMethods: new PageMethodsMock(new OverridenPageMethodsResponses()),
                racingPageMethods: new RacingPageMethodsMock(),
                getUniqueOddsClass: GetUniqueClassMock
            },
                {
                    betSlipUtil: new BetSlipUtilMock(),
                    oddsUtil: new OddsMock(),
                    facade: new PushOddsFacadeMock()
                },
                options.cms,
                () => { }
            );

            //export data store to window for debug purposes
            window["RacingNextRacesDATA"] = this.dataProvider;
        }

        if (process.env.NODE_ENV === "production" && typeof options.dataProvider !== "undefined") {

            // use pagemethods passed during the construction from the
            // mobile application
            this.dataProvider = new RacingNextRacesData(
                options.dataProvider,
                {
                    betSlipUtil: options.betSlipUtil,
                    oddsUtil: options.oddsUtil,
                    facade: options.facade
                },
                options.cms,
                OpenRacingGame
            );
        }
    }

    activate() {
        return super.activate(
            <RacingNextRaces dataProvider={this.dataProvider} dict={this.options.dict} />
        );
    }
}

window["RacingNextRaces"] = RacingNextRacesRoot;
broadcastBlockLoad("RacingNextRaces");